'use client'

import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'
import Track from 'src/components/Track'
import SignUpForm from './SignUp'

const RegisterContent = () => {
    const searchParams = useSearchParams()
    const code = searchParams.get('code')
    const signupEnabled = code !== null && code !== ''
    return (
        <>
            <Track eventName={signupEnabled ? 'signupVisited' : 'waitlistVisited'} />
            <SignUpForm />
        </>
    )
}

export default function Register() {
    return (
        <Suspense>
            <RegisterContent />
        </Suspense>
    )
}
